import React from 'react'

const Chip = props => {
  const theme = props.theme || "light";
  const chipThemes = {
    light: "grey lighten-3",
    dark: "grey darken-3 white-text",
    user: "grey lighten-3",
    system: "blue lighten-1 white-text",
  };
  const chipClasses = `${chipThemes[theme]} chip chip--no-shadow mb-0`;

  return <div onClick={props.onClick} className={chipClasses}> {props.children} </div>
}

export default Chip
